// reset redirecting flag in case back button was clicked in the browser
window.addEventListener('pageshow', function () { window.isBeingRedirected = false; });

(($, w) => {
    const gtmImpressionsChunkSize = 30;
    const assetId = 'gtm-eec-prod-list';

    let userInfo = null;
    if (w.umwAssets && w.umwAssets[assetId] && w.umwAssets[assetId].length) {
        userInfo = w.umwAssets[assetId][0];
    }

    w.PubSub.subscribe('externaltracking.product.listview', (_, productImpressions) => {
        if (productImpressions && productImpressions.items && productImpressions.items.length > 0) {
            processImpressions(productImpressions);
        }
    });

    function processImpressions(productListImpressions) {
        const listName = productListImpressions.listName || document.title;
        const allProducts = productListImpressions.items;
        const totalProductsCount = allProducts.length;
        var $allProductLinks = $(); 
        var idx = 0, chunkIdx = 0;
        const utils = new GtmUtils();
        const currencyCode = utils.getCurrencyCode(productListImpressions);
        while (idx < totalProductsCount) {
            const positionShift = chunkIdx * gtmImpressionsChunkSize;

            const products = allProducts.slice(idx, idx += gtmImpressionsChunkSize);
            const gtmProducts = [];

            for (var i = 0, l = products.length; i < l; i++) {
                const prod = products[i];
                const positionInList = positionShift + i + 1;
                const gtmProd = utils.convertToGtmEecProduct(prod, { 'list': listName, 'position': positionInList });
                if (gtmProd) {
                    gtmProducts.push(gtmProd);

                    if (prod.$links) {
                        prod.$links.data('gtm-product', gtmProd);
                        prod.$links.data('listname', listName);
                        prod.$links.data('currencycode', currencyCode);

                        $allProductLinks = $allProductLinks.add(prod.$links);
                    }
                }
            }

            const impressionViewEvent = {
                'event': 'eec.impressionView',
                'ecommerce': {
                    'currencyCode': currencyCode,
                    'impressions': gtmProducts
                }
            };
            
            if (userInfo) {
                impressionViewEvent.user = userInfo;
            }

            w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            w.dataLayer.push(impressionViewEvent);

            ++chunkIdx;
        }

        if ($allProductLinks.length > 0) {
            $allProductLinks.on('click', function (evt) {
                try {
                    if (w['google_tag_manager']) {
                        var targetUrl = this.href;
                        const $this = $(this);

                        const productClickEvent = {
                            'event': 'eec.productClick',
                            'ecommerce': {
                                'currencyCode': $this.data('currencycode') || utils.getCurrencyCode(),
                                'click': {
                                    'actionField': { 'list': $this.data('listname') },
                                    'products': [$this.data('gtm-product')]
                                }
                            },
                            'eventCallback': function () {
                                if (!w.isBeingRedirected) {
                                    document.location = targetUrl;
                                    w.isBeingRedirected = true;
                                }
                            },
                            'eventTimeout': 1000
                        };

                        w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                        w.dataLayer.push(productClickEvent);

                        evt.preventDefault();
                    }
                } catch (e) {
                    console.error('[GTM]: Failed to push product click event to dataLayer. Reason: ' + e);
                }
            });
        }
    }
})(jQuery, window);